import React from 'react'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'

import StatusField from '~/components/Fields/StatusField'
import TextField from '~/components/Fields/TextField'

function WooCommerce ({ disabled }) {
  return (
    <>
      <Grid item={true} xs={12} lg={4}>
        <TextField
          data-cy="name"
          name="name"
          label="Name"
        />
      </Grid>
      <Grid item={true} xs={12} lg={4}>
        <TextField
          data-cy="storeDomain"
          name="storeDomain"
          label="Shop domain"
          disabled={disabled}
          inputProps={{
            placeholder: 'https://woocommerce.example.app'
          }}
        />
      </Grid>

      <Grid item={true} xs={12} lg={4}>
        <StatusField />
      </Grid>

      <Grid item={true} xs={12}>
        <TextField
          data-cy="description"
          name="description"
          label="Description"
          multiline={true}
          minRows={4}
        />
      </Grid>
    </>
  )
}

WooCommerce.propTypes = {
  disabled: PropTypes.bool
}

export default WooCommerce
